<template>
  <div id="app">
    <div class="over-all" v-if="isSetting"></div>
    <router-view />
  </div>
</template>
<script>
import { URLS } from "fire-wind-water";
export default {
  name: "App",
  data() {
    return {
      isSetting: URLS.getURL("isSetting"),
    };
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
